import "@hotwired/turbo-rails"
import { createConsumer } from "@rails/actioncable"
import "../controllers"

window.Cable = createConsumer()
